module.exports = __webpack_public_path__ + "static/media/progress_referenznummer.ae1749f2.svg";